import { first, share } from 'rxjs/operators';

import type { EffectParams } from '@swf/core/store';
import { select } from '@swf/core/store';

export const checkAuth = ({
  dispatch,
  rootState,
  actions
}: Omit<EffectParams, 'request' | 'addModel' | 'select'>) => {
  if (!select.session.isAuthenticated(rootState)) {
    dispatch.modal.enqueue({ path: '/auth/login' });
    return actions.pipe(
      first(({ type, state }) => select.session.isAuthenticated(state)),
      share()
    );
  }
  return undefined;
};

export interface NavItem {
  text: string;
  url: string;
}

export const getActive = (pathname: string, items: NavItem[]): string[] =>
  items
    .map((item) => item.url)
    .filter<string>((url): url is string =>
      url ? pathname.endsWith(url) || pathname.endsWith(`${url}/`) : false
    )
    .sort((a, b) => b.length - a.length);
